import { Box } from "@mui/material"
import { AttendanceBoard } from "views/Attendance"
import EmployeesBoard from "views/Employees/EmployeesBoard"
import { ErrorPage } from "views/Error"
import { Profile } from "views/Profile"
import { RequestLeaveBoard } from "views/RequestLeave"
import { RequestStatisticsBoard } from "views/RequestStatistics"

const privateRoute = {
  employees: {
    component: EmployeesBoard,
    name: "Nhân viên",
    path: "/employees",
  },
  errors: {
    component: ErrorPage,
    name: "Lỗi",
    path: "/errors/:code",
  },
  home: {
    component: AttendanceBoard,
    name: "Trang chủ",
    path: "/",
  },
  profile: {
    component: Profile,
    name: "Profile",
    path: "/profile",
  },
  requestLeave: {
    component: RequestLeaveBoard,
    name: "Xin nghỉ",
    path: "/request-leaves",
  },
  requestStatistics: {
    component: RequestStatisticsBoard,
    name: "Báo cáo yêu cầu",
    path: "/request-statistics",
  },
  settings: {
    component: Box,
    name: "Cài đặt",
    path: "/settings",
  },
  works: {
    component: AttendanceBoard,
    name: "Chấm công",
    path: "/works",
  },
}
export default privateRoute
